export const checkinMisc = {
  authorityBadges: {
    states: {
      ok: "تم الإرسال بنجاح",
      error: "خطأ في الإرسال",
      notConfigured: "غير مُهيأ",
      pending: "في انتظار الإرسال",
    },
    errorNoInfo: "خطأ (لا توجد تفاصيل)",
  },
  msgPolice: {
    title: "معلومات",
    pendingSyncText:
      "بيانات تسجيل الوصول في انتظار المزامنة، وسيتم إرسالها إلى السلطات المحلية في نفس يوم وصول النزيل إلى مكان الإقامة.",
    entryDateLabel: "تاريخ الوصول:",
    syncedText:
      "تمت مزامنة بيانات النزيل {name} مع السلطات المحلية بنجاح.",
    syncDateLabel: "تاريخ المزامنة:",
    errorText:
      "تعذّر إتمام المزامنة مع السلطات المحلية لأسباب خارجية.",
    close: "إغلاق",
  },
};
